import {
    Component,
    Injectable,
    OnInit,
    ViewChild,
    Inject,
    ElementRef,
    NgZone,
    ChangeDetectorRef,
    ViewContainerRef, ApplicationRef
} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UIHelper} from './uihelper';
import {Message} from 'primeng/primeng';
import {Router} from "@angular/router";
import {AppValidator} from "./app-validator";
import {TranslateService} from "@ngx-translate/core";
import {Location} from "@angular/common";
import {CookieService} from "ngx-cookie-service";
import {ComponentBase} from "./modules/component-base";
import {AppCurrentModule} from "./app-current-module";
import {AccountHandlingComponent} from "./common/account-handling.component";
//import 'rxjs/add/operator/share';
//import 'rxjs/add/operator/map';
// Import these modules to create side-effects.
//import "rxjs/add/observable/of";

declare var $: any;

@Component({
    //moduleId: __moduleName.replace("/dist/out-tsc/", "/src/"),
    moduleId: __moduleName,
    //moduleId: module.id,
    selector: 'main-app',
    templateUrl: './app.component.html'
})
@Injectable()
export class AppComponent extends ComponentBase implements OnInit {

    lastHttpUrl = '';

    @ViewChild('txtPassword') txtPassword;
    @ViewChild('txtUsername') txtUsername;

    @ViewChild('accountHandling') accountHandlingComponent: AccountHandlingComponent;

    loginErrorMessage: Message[] = [];

    username: string = '';
    password: string = '';
    //remember: boolean;
    noAutoLogout: boolean;

    http: HttpClient;

    static instance: AppComponent;
    translateService: TranslateService;
    public router: Router;
    appElement: ElementRef;
    public zone: NgZone;
    public appValidator: AppValidator = new AppValidator();
    public changeDetectorRef: ChangeDetectorRef;
    viewContainerRef: ViewContainerRef;
    applicationRef: ApplicationRef;

    appCurrentModule: AppCurrentModule = null;
    appTmpStore: any = null;
    initialData: any = null;
    lastInitialData: any = null;

    appData: any;
    public uniqueIDSerial: number = Date.now();
    public externalLinks: { [id: string]: string; } = {};

    public tmpStore = {};

    public preventTabEnter = false;

    checkOnUnload = false;

    sysRole = '';

    constructor(/* router: Router,*/ http: HttpClient, translate: TranslateService/*, location: Location*/, appElement: ElementRef, zone: NgZone, viewContainerRef: ViewContainerRef, changeDetectorRef: ChangeDetectorRef, applicationRef: ApplicationRef, cookieService: CookieService) {
        super();
        this.http = http;
        AppComponent.instance = this;
        this.viewContainerRef = viewContainerRef;
        this.changeDetectorRef = changeDetectorRef;
        this.applicationRef = applicationRef;
        this.cookieService = cookieService;
        this.sysRole = getSysRole();
    }

    ngOnInit() {
        if (appSettingsData !== "") {
            try {
                appSettingsData = JSON.parse(Base64.decode(appSettingsData));
            } catch (e) {
                appSettingsData = {};
            }
        }

        if (typeof appSettingsData !== 'undefined' && appSettingsData['act'] !== 'undefined') {
            let act = appSettingsData['act'];
            if (act != null) {
                if (act == 'pwreset') {
                    setTimeout(() => {
                        this.accountHandlingComponent.showPasswordReset(appSettingsData['tkn']);
                    });
                }
                if (act == 'register') {
                    setTimeout(() => {
                        this.accountHandlingComponent.showRegistration(appSettingsData['tkn']);
                    });
                }
            }
        }
    }

    usernameOnEnter(event) {
        this.txtPassword.nativeElement.focus();
        this.txtPassword.nativeElement.select();

    }

    passwordOnEnter(event) {
        this.doLogin()
    }

    public addGrowlMessage(type: string, summary: string, detail: string = "") {
        switch (type) {
            case 'error':
                this.addGrowlErrorMessage(summary, detail);
                break;
            case 'warning':
                this.addGrowlWarningMessage(summary, detail);
                break;
            case 'notice':
                this.addGrowlNoticeMessage(summary, detail);
                break;
            case 'info':
            default:
                this.addGrowlInfoMessage(summary, detail);
                break;
        }
    }

    public addStickyGrowlMessage(type: string, summary: string, detail: string = "") {
        switch (type) {
            case 'error':
                this.addStickyGrowlErrorMessage(summary, detail);
                break;
            case 'warning':
                this.addStickyGrowlWarningMessage(summary, detail);
                break;
            case 'notice':
                this.addStickyGrowlNoticeMessage(summary, detail);
                break;
            case 'info':
            default:
                this.addStickyGrowlInfoMessage(summary, detail);
                break;
        }
    }

    public addGrowlErrorMessage(summary: string, detail: string = "") {
        $.growl.error({
            title: summary,
            message: detail
        });
    }

    public addGrowlInfoMessage(summary: string, detail: string = "") {
        $.growl({
            title: summary,
            message: detail
        });
    }

    public addGrowlWarningMessage(summary: string, detail: string = "") {
        $.growl.warning({
            title: summary,
            message: detail
        });
    }

    public addGrowlNoticeMessage(summary: string, detail: string = "") {
        $.growl.notice({
            title: summary,
            message: detail
        });
    }

    public addStickyGrowlErrorMessage(summary: string, detail: string = "") {
        /*
         this.generalStickyErrorMessage = [];
         this.generalStickyErrorMessage.push({severity: 'error', summary: summary, detail: detail});
         */
        $.growl.error({
            title: summary,
            message: detail,
            duration: 14 * 24 * 60 * 60 * 1000
        });
    }

    public addStickyGrowlInfoMessage(summary: string, detail: string = "") {
        /*
         this.generalStickyErrorMessage = [];
         this.generalStickyErrorMessage.push({severity: 'info', summary: summary, detail: detail});
         */
        $.growl({
            title: summary,
            message: detail,
            duration: 14 * 24 * 60 * 60 * 1000
        });
    }

    public addStickyGrowlWarningMessage(summary: string, detail: string = "") {
        /*
         this.generalStickyErrorMessage = [];
         this.generalStickyErrorMessage.push({severity: 'warn', summary: summary, detail: detail});
         */
        $.growl.warning({
            title: summary,
            message: detail,
            duration: 14 * 24 * 60 * 60 * 1000
        });
    }

    public addStickyGrowlNoticeMessage(summary: string, detail: string = "") {
        $.growl.notice({
            title: summary,
            message: detail,
            duration: 14 * 24 * 60 * 60 * 1000
        });
    }

    doLogin() {
        this.txtUsername.nativeElement.focus();
        this.txtUsername.nativeElement.select();
        disableUser();
//console.log(this.username);
        //UIHelper.doPostJSON(this.http, this, '/login', {username: this.username, password: this.password, remember: this.remember}).subscribe(

        UIHelper.doPostJSON(this.http, this, getApiUrl() + '/authenticate',
            //UIHelper.doPostJSON(this.http, this, '/login?doLogin',
            {
                user: this.username,
                password: this.password
            }, true, false, true)
            .subscribe(
                resultData => {
                    enableUser();
                    this.loginErrorMessage = [];
                    //if (typeof resultData.result !== 'undefined' && resultData.result == 'SUCCESS') {
                    //window.location.reload();
                    //}
                    if (typeof resultData.token !== 'undefined') {
                        console.log(window.location.href);
                        sessionStorage.setItem('userData', JSON.stringify(resultData));
                        sessionStorage.setItem('loginName', this.username);
                        document.cookie = "gui=main; path=/";
                        let newLocation = window.location.href.split('?')[0];
                        let newLocationWoHash = newLocation.split('#')[0];
                        if (newLocationWoHash == window.location.href) {
                            window.location.reload();
                        } else {
                            window.location.href = newLocationWoHash;
                        }
                    } else {
                        try {
                            this.loginErrorMessage.push({
                                severity: 'error',
                                summary: resultData.result.resultMessage,
                                detail: ''
                            });
                            this.loginErrorMessage = resultData.result.resultMessage;
                        } catch (e) {
                            this.loginErrorMessage.push({
                                severity: 'error',
                                summary: 'Ismeretlen hiba, kérem próbálja újra!',
                                detail: ''
                            });
                        }
                    }
                },
                error => {
                    this.loginErrorMessage = [{severity: 'error', summary: error.error.message, detail: ''}];
                    enableUser();
                }
            );

    }

    public getTranslation(key: string) {
        let result = '';
        this.translateService.get(key).subscribe((res: string) => {
            result = res;
        });
        return result;
    }

}
